import { defineMessages } from 'react-intl';

export default defineMessages({
  charityVettingKrsRequiredPL: {
    id: 'charityVetting.pl.krs.required',
    defaultMessage: 'The KRS number is required.',
  },
  charityVettingKrsInvalidPL: {
    id: 'charityVetting.pl.krs.invalid',
    defaultMessage: 'Invalid format. The KRS number must contain 10 digits.',
  },
  charityVettingNipRequiredPL: {
    id: 'charityVetting.pl.nip.required',
    defaultMessage: 'The NIP is required.',
  },
  charityVettingNipInvalidPL: {
    id: 'charityVetting.pl.nip.invalid',
    defaultMessage: 'Invalid format. The NIP must contain 10 digits.',
  },
});
